export const normalizeName = (value = '') => {
    return String(value || '')
        .toLowerCase()
        .replace(/\+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/\(\s+/g, '(')
        .replace(/\s+\)/g, ')')
        .trim();
};

export const normalizeCompanyName = (value = '') => {
    const normalized = normalizeName(value);
    if (normalized === 'js' || normalized === 'jsis' || normalized.includes('jindal steel')) {
        return 'jindal steel';
    }
    if (normalized === 'ss' || normalized.includes('sohar steel')) {
        return 'sohar steel';
    }
    return normalized;
};

export const normalizeSectionName = (value = '') => normalizeName(value);

export const normalizeDepartmentName = (value = '') => normalizeName(value);

export const isSmsSection = (value = '') => {
    const normalizedValue = normalizeSectionName(value);
    return normalizedValue === 'sms'
        || normalizedValue === 'sms (steel melting shop)'
        || normalizedValue === 'steel melting shop (sms)'
        || normalizedValue === 'steel melt shop (sms)'
        || normalizedValue === 'jss-sms';
};

export const isRollingMillSection = (value = '') => {
    const normalizedValue = normalizeSectionName(value);
    return normalizedValue === 'rolling mill' || normalizedValue === 'rm';
};

export const isDriSection = (value = '') => {
    const normalizedValue = normalizeSectionName(value);
    return normalizedValue === 'dri' || normalizedValue === 'dri (direct reduced iron)';
};

export const isJettySection = (value = '') => {
    const normalizedValue = normalizeSectionName(value);
    return normalizedValue === 'jetty' || normalizedValue === 'jetty & mh';
};

// export const isUtilitySection = (value = '') => {
//     const normalizedValue = normalizeSectionName(value);
//     return normalizedValue === 'utility';
// };
export const isUtilityDepartment = (value = '') => {
    const normalizedValue = normalizeDepartmentName(value);
    return normalizedValue === 'utility' || normalizedValue.includes('utility');
}